export default __webpack_public_path__ + "static/media/logo-main.44d66835.png";